<section class="otp-recovery-form flex flex-wrap justify-content-center">
  <p class="text-center w-full">Per procedere occorre inserire il codice inviato sulla mail</p>

  <form [formGroup]="otpForm">
    <p class="w-full">Codice OTP:</p>
    <input type="text" pInputText class="w-full flex justify-content-center" formControlName="otp">
    <div class="flex flex-wrap mt-4 gap-2">
      <button pButton pRipple type="submit" class="p-button w-full p-button-rounded justify-content-center" (click)="onSubmit()">Invia</button>
      <button pButton pRipple type="submit" pTooltip="Se non hai ancora ricevuto l'OTP clicka qui" class="p-button-outlined w-full p-button-rounded justify-content-center"
              (click)="newOtpRequest()" [disabled]="newOtpDisabled">Richiedi nuovamente OTP</button>
    </div>
  </form>

  <div *ngIf="errorMessage">
    <p>{{errorMessage}}</p>
  </div>
</section>
